import type { TFunction } from "i18next";

/**
 * Format a byte count into a human-readable string using i18n-aware unit labels.
 *
 * Uses the `documents:size_kb` / `documents:size_mb` translation keys so the
 * unit suffix matches the active locale (e.g. "KB" in English, "Ko" in French).
 */
export function formatBytes(bytes: number, t: TFunction): string {
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} ${t("documents:size_kb")}`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} ${t("documents:size_mb")}`;
}
